export enum PriceCode {
    Subtotal = "subtotal",
    AdjustedWholesale = "adjusted_wholesale_total",
    WholesaleTotal = "wholesale_total",
}
